module.exports = __webpack_public_path__ + "img/ado-virtual.0bee3890.png";